<template>
    <div>
        <v-dialog v-model="commonKpiDialog" persistent max-width="900px">
          <v-card>
            <v-card-title style="position:sticky;top:0;z-index:10;">
                <span v-if="isEditCommonKPI">{{$t('performancemanagement.editcommonkpi')}}</span>
                <span v-else>{{$t('performancemanagement.addcommonkpi')}}</span>
            </v-card-title>
            <v-card-text class="pt-4">
              <v-container>

                    <!-- <v-row class="pb-n4">
                        <v-col cols="12" sm="12" class="pb-n4 pl-0 mt-n4">
                            <v-autocomplete
                                outlined
                                :label="$t('performancemanagement.commonkpilist')"
                                type="text"
                                ref="commonKpiItemId"
                                v-model="commonKpiItemId"
                                dense
                                :items="KpiItemCommonList"
                                @input="updateValue"
                                @change="changeKpiItemIntoSelection(commonKpiItemId)"
                            ></v-autocomplete>
                        </v-col>
                    </v-row> -->
                    <v-row class="pb-n4">
                        <v-text-field
                            outlined
                            :label="$t('columns.description')"
                            type="text"
                            ref="description"
                            v-model="selections.description"
                            @input="updateValue"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-row>

                    <v-row class="pb-n4 mt-n4">
                        <v-text-field
                            outlined
                            :label="$t('pmreviewexercisesectioncard.goal')"
                            type="text"
                            ref="goal"
                            v-model="selections.goal"
                            @input="updateValue"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-row>

                    <v-row class="pb-n4 mt-n4">
                        <v-text-field
                            outlined
                            :label="$t('pmreviewexercisesectioncard.KPI')"
                            type="text"
                            v-model="selections.kpi"
                            ref="kpi"
                            @input="updateValue"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-row>

                    <v-row class="mt-n1">
                        <v-col cols="5" sm="5" class="pb-n4 pl-0 mt-n4">
                            <v-autocomplete
                                outlined
                                :label="$t('performancemanagement.targetoption')"
                                type="text"
                                ref="pmtargetoptionid"
                                v-model="selections.pmtargetoptionid"
                                dense
                                :items="targetOptionList"
                                @input="updateValue"
                                @change="changeTargetOption(selections.pmtargetoptionid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="5" sm="5" class="pb-n4 pl-0 mt-n4">
                            <v-autocomplete
                                outlined
                                :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                type="text"
                                ref="pmcalmethodid"
                                v-model="selections.pmcalmethodid"
                                dense
                                :items="calculationMethodList"
                                @input="updateValue"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 px-0 mt-n4">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.weightage')"
                                type="number"
                                v-model="selections.weightage"
                                ref="weightage"
                                @input="updateValue"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-row>
                                <v-col v-if="selections.targetType !== 'Target only'" cols="4" sm="4" class="pl-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.threshold')"
                                        type="number"
                                        v-model="selections.threshold"
                                        ref="threshold"
                                        @input="updateValue"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" sm="4" class="pl-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('columns.target')"
                                        type="number"
                                        v-model="selections.target"
                                        ref="target"
                                        @input="updateValue"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="selections.targetType !== 'Target only'" cols="4" sm="4" class="px-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.stretch')"
                                        type="number"
                                        v-model="selections.stretch"
                                        ref="stretch"
                                        @input="updateValue"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" class="pb-n4 mt-n8 pl-0">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.company')"
                                type="text"
                                ref="companyid"
                                v-model="selections.companyid"
                                :items="companyList"
                                @input="updateValue"
                                @change="changeCompany(selections.companyid)"
                                dense
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pb-n4 mt-n8 px-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.companycode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" class="pb-n4 mt-n8 pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.branch')"
                                type="text"
                                ref="branchid"
                                v-model="selections.branchid"
                                dense
                                :items="branchList"
                                @input="updateValue"
                                @change="changeBranch(selections.branchid)"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pb-n4 mt-n8 px-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.branchcode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" class="pb-n4 mt-n8 pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.division')"
                                type="text"
                                ref="compnyid"
                                v-model="selections.divid"
                                dense
                                :items="divisionList"
                                @input="updateValue"
                                @change="changeDivision(selections.divid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pb-n4 mt-n8 px-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.divisioncode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" class="pb-n4 mt-n8 pl-0">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.department')"
                                type="text"
                                ref="deptid"
                                v-model="selections.deptid"
                                dense
                                :items="departmentList"
                                @input="updateValue"
                                @change="changeDepartment(selections.deptid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pb-n4 mt-n8 px-0">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.departmentcode"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveCommonKpiInput">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeCommonKpiInput">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-container style="max-width:100%;padding-left:0;padding-right:0;overflow-x:hidden;">
            <v-row class="mt-4">
                <v-col cols="12" class="pb-n5 mt-n8 px-4">
                    <v-toolbar flat>
                        <v-row align="center" no-gutters>
                            <v-col cols="auto">
                                <span class="review-stats-label pl-2">{{$t('pmreviewexercisesectioncard.commonkpi')}}</span>
                            </v-col>
                            <v-col cols="auto" class="ml-3">
                                <v-btn color="primary" dark small @click="openCommonnKpiInput">+</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <div class="export-icon-btns mr-2">
                                <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                                  PDF
                                </button>
                                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                                  CSV
                                </button>
                            </div>
                        </v-row>
                    </v-toolbar>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="px-4">
                    <v-data-table
                        :headers="this.parentObject.tabHeader"
                        :items="detailItem"
                        class="elavation-1"
                        fixed-header
                        :sort-by="['code']"
                    >
                        <template v-slot:[`item.action`]="{ item }">
                            <img 
                                :src="`${publicPath}images/paper.svg`" 
                                alt="SVG Icon" 
                                @click="onAdvanceEditItem(item)" 
                                class="ml-5 mt-2"
                                style="width: 15px; height: 18px; cursor: pointer;"
                            />
                            <v-icon
                                small
                                class="ml-2 mr-2"
                                @click="modifyItemHandler(item)"
                            >
                                mdi-pen
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItemHandler(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: null,
            publicPath: process.env.BASE_URL,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            commonKpiDialog: false,
            detailItem: this.parentObject.detailItem,
         
            selections: {
                kpiexerid: this.$route.params.id,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                description: null,
                weightage: null,
                goal: null,
                kpi: null,
                target: null,
                threshold: null,
                stretch: null,
                companyid: null,
                branchid: null,
                deptid: null,
                divid: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                targetType: null,
                companycode: null,
                branchcode: null,
                divisioncode: null,
                departmentcode: null,
            },

            targetOptionFull: [],
            targetOptionList: [],

            // calculationMethodFull: [],
            calculationMethodList: [],

            companyFull: [],
            companyList: [],

            branchFull: [],
            branchList: [],

            departmentFull: [],
            departmentList: [],

            divisionFull: [],
            divisionList: [],

            KpiItemCommonFull:[],
            KpiItemCommonList:[],
            commonKpiItemId:null,//use to populate the data
            
            //error msg and dialog, check for duplicates vars
            // isExisting: false,
            isErr: false,
            isEditCommonKPI: false,
            errMsg: '',
        }
    },

    methods: {
        compareArray,

        printPDF() {
            const doc = new (require('jspdf').jsPDF)({ orientation: 'landscape' });
            const headers = this.parentObject.tabHeader
                .filter(h => h.value !== 'action')
                .map(h => ({ title: h.text, dataKey: h.value }));
            const body = this.detailItem.map(item =>
                headers.reduce((o, h) => { o[h.dataKey] = item[h.dataKey] || ''; return o; }, {})
            );
            doc.text('Common KPI', 10, 10);
            doc.autoTable({ head: [headers.map(h => h.title)], body: body.map(r => Object.values(r)), startY: 20, styles: { fontSize: 7, cellPadding: 1 } });
            doc.save('CommonKPI.pdf');
        },

        objectToCSV(data) {
            if (!data || !data.length) return '';
            const headers = Object.keys(data[0]);
            const rows = data.map(row => headers.map(h => `"${('' + (row[h] || '')).replace(/"/g, '\\"')}"`).join(','));
            return [headers.join(','), ...rows].join('\n');
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('hidden', '');
            a.setAttribute('href', url);
            a.setAttribute('download', 'CommonKPI.csv');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        getCSV() {
            const cols = this.parentObject.tabHeader.filter(h => h.value !== 'action');
            const data = this.detailItem.map(item =>
                cols.reduce((o, h) => { o[h.text] = item[h.value] || ''; return o; }, {})
            );
            this.download(this.objectToCSV(data));
        },

        onAdvanceEditItem(item) {
            this.$router.push({ name: "kpisettingeditcommonkpi", params: { id: item.id, kpiexerid: this.selections.kpiexerid, commonDetails: item } });
        },
      
        modifyItemHandler(item) {
            this.loadKpiCommonHandler(item);
            this.isEditCommonKPI = true;
            this.commonKpiDialog = true;
        },

        deleteItemHandler(item) {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('performancemanagement.delete', { code: item.description }))) {
                this.$store.dispatch('delete', {
                    url: "/kpicommon/" + item.id + '/' + this.$store.getters.userId
                })
                    .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    } else {
                        let itemIndex = this.detailItem.indexOf(item);
                        this.detailItem.splice(itemIndex, 1);
                    }
                    })
                    .catch((err) => {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = err;
                    });
            }
        },

        openCommonnKpiInput() {
            this.commonKpiDialog = true;
        },

        async saveCommonKpiInput() {

            const vm = this;

            if(vm.isEditCommonKPI) {

                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                vm.selections.userid = vm.$store.getters.userId;

                await vm.$store.dispatch('put', {url: "/kpicommon/" + vm.id, payload: vm.selections})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    }
                    else{
                        vm.isErr = false;
                        vm.resetFormAndReload();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            } else {

                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                await this.$store.dispatch('post', {url: "/kpicommon/create", payload: vm.selections})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.detailItem.push(res.data.rec);
                        vm.isErr = false;
                        vm.resetFormAndReload();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        // Method to reset form and reload
        resetFormAndReload() {
            // Reset the form fields
            this.commonKpiDialog = false;
            this.isEditCommonKPI = false;
            this.resetSelections();

            // Refresh Common Kpi List
            this.$emit('reload');
        },

        loadKpiCommonHandler(item) {
            this.resetSelections();
            this.id = item.id;
            this.selections = item;
            this.changeTargetOption(item.pmtargetoptionid);
            this.changeCompany(item.companyid);
            this.changeBranch(item.branchid);
            this.changeDivision(item.divid);
            this.changeDepartment(item.deptid);
        },

        closeCommonKpiInput() {
            this.commonKpiDialog = false;
            this.isEditCommonKPI = false;
            this.isErr = false;
            
            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.id = null;
            this.selections = {
                kpiexerid: this.$route.params.id,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                description: null,
                weightage: null,
                goal: null,
                kpi: null,
                target: null,
                threshold: null,
                stretch: null,
                companyid: null,
                branchid: null,
                deptid: null,
                divid: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                targetType: null,
                companycode: null,
                branchcode: null,
                divisioncode: null,
                departmentcode: null,
            };
            this.commonKpiItemId= null;
        }, 
        
        updateValue() {
            this.$emit('input', {
                kpiexerid: this.$route.params.id,
                pmtargetoptionid: this.selections.pmtargetoptionid,
                pmcalmethodid: this.selections.pmcalmethodid,
                description: this.selections.description,
                weightage: this.selections.weightage,
                goal: this.selections.goal,
                kpi: this.selections.kpi,
                target: this.selections.target,
                threshold: this.selections.threshold,
                stretch: this.selections.stretch,
                companyid: this.selections.companyid,
                branchid: this.selections.branchid,
                deptid: this.selections.deptid,
                divid: this.selections.divid,
                targetType: this.selections.targetType,
                companycode: this.selections.companycode,
                branchcode: this.selections.branchcode,
                divisioncode: this.selections.divisioncode,
                departmentcode: this.selections.departmentcode,
            });
        },

        changeTargetOption(id) {
            let item = this.targetOptionFull.find((item) => item.id === id);
            this.selections.targetType = item.targetoption;
        },

        //load target option list
        loadTargetOptionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpitargetoption/all' })
            .then((res) => {

                vm.targetOptionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.targetOptionList.push({
                        text: res.data.rec[i].targetoption,
                        value: res.data.rec[i].id,
                    });
                }

                // if (vm.selections.pmtargetoptionid) {
                //     vm.changeTargetOption(vm.selections.pmtargetoptionid);
                // }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        // changeCalculationMethod(id) {
        //     let item = this.calculationMethodFull.find((item) => item.id === id);
        //     this.selections.workflowrole = item.role;
        // },

        //load target option list
        loadCalculationMethodListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpicalculationmethod/all' })
            .then((res) => {

                // vm.calculationMethodFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.calculationMethodList.push({
                        text: res.data.rec[i].calmethod,
                        value: res.data.rec[i].id,
                    });
                }

                // if (vm.selections.pmcalmethodid) {
                //     vm.changeCalculationMethod(vm.selections.pmcalmethodid);
                // }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeCompany(id) {
            let item = this.companyFull.find((item) => item.id === id);
            this.selections.companycode = item.compnycode;
        },

        loadCompanyListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url: `/company/allfilter/${this.$store.getters.userId}`})
            .then((res) => {

                vm.companyFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.companyList.push({
                        text: res.data.rec[i].compnyname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeBranch(id) {
            let item = this.branchFull.find((item) => item.id === id);
            this.selections.branchcode = item?.brchcode ?? null;
        },

        loadBranchListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/branch/all"})
            .then((res) => {
                vm.branchFull = res.data.rec;
    
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.branchList.push({
                        text: res.data.rec[i].brchname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeDivision(id) {
            let item = this.divisionFull.find((item) => item.id === id);
            this.selections.divisioncode = item?.divncode ?? null;
        },

        loadDivisionListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/division/all"})
            .then((res) => {
                vm.divisionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.divisionList.push({
                        text: res.data.rec[i].divnname,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeDepartment(id) {
            let item = this.departmentFull.find((item) => item.id === id);
            this.selections.departmentcode = item?.deptcode ?? null;
        },

        loadDepartmentListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/department/all"})
            .then((res) => {
                vm.departmentFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.departmentList.push({
                        text: res.data.rec[i].deptname,
                        value: res.data.rec[i].id,
                    });
                }
                })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        loadKpiItemCommonListHandler() {
            const vm = this;
    
            this.$store.dispatch('get', {url:  "/kpiitem/common"})
            .then((res) => {
                vm.KpiItemCommonFull = res.data.rec;

                for (let i = 0; i < vm.KpiItemCommonFull.length; i++) {
                    vm.KpiItemCommonList.push({
                        text: res.data.rec[i].goal,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
            });
        },

        changeKpiItemIntoSelection(id) {
            const selectedItem = this.KpiItemCommonFull.find(item => item.id === id);

            this.selections.description=selectedItem.description;
            this.selections.goal=selectedItem.goal;
            this.selections.kpi=selectedItem.kpi;
            this.selections.pmtargetoptionid=selectedItem.pmtargetoptionid;
            this.changeTargetOption(this.selections.pmtargetoptionid);
            this.selections.pmcalmethodid=selectedItem.pmcalmethodid;
            this.selections.weightage=selectedItem.weightage;
            this.selections.threshold=selectedItem.threshold;
            this.selections.target=selectedItem.target;
            this.selections.stretch=selectedItem.stretch;
        },
    },
    
    mounted() { 
        this.loadTargetOptionListHandler();
        this.loadCalculationMethodListHandler();
        this.loadCompanyListHandler();
        this.loadBranchListHandler();
        this.loadDivisionListHandler();
        this.loadDepartmentListHandler();
        this.loadKpiItemCommonListHandler();
    },
}
</script>

<style scoped>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: -8px;
}

.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }

.mdi-pen::before {
  margin-top: -8px;
}
</style>